<template>
  <div class="error-page">
    <p class="error-message">{{ this.$t("pages.wording."+this.desc ) }}</p>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    desc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      desc: "",
    }
  },
  components: {},
  methods: {
    getErrorDesc() {
      switch (this.$route.name) {
        case "NoAuthorized":
          this.desc = "unAuthoried"
          break
        case "NotFound":
          this.desc = "notFound"
          break
        case "Error":
          this.desc = "error"
          break
        default:
          this.desc = "error"
      }
    },
  },
  mounted() {
    this.getErrorDesc()
  },
}
</script>

<style scoped>
.error-page {
  text-align: center;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.error-message {
  font-size: 20px;
  margin-bottom: 20px;
  color: #00a0e9;
}

.error-page h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}
</style>
